export default __webpack_public_path__ + "static/media/NotoKufiArabic-Bold.cede634e.ttf";